import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import {
  listSupportCenter as listSupportCenterService,
  updateSupportCenter as updateSupportCenterService,
} from "../../services/SupportCenterService";
import {
  SupportCenters,
  SupportCenterState,
} from "../../interfaces/support-interface";

export const listSupportCenters = createAsyncThunk(
  "support/listSupportCenters",
  async (_, thunkAPI) => {
    const token = localStorage.getItem("idToken");

    if (!token) {
      return thunkAPI.rejectWithValue("No authentication token found.");
    }

    try {
      const response = await listSupportCenterService(token);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const updateSupportCenter = createAsyncThunk(
  "support/updateSupportCenter",
  async (data: Object, thunkAPI) => {
    const token = localStorage.getItem("idToken");

    if (!token) {
      return thunkAPI.rejectWithValue("No authentication token found.");
    }

    try {
      const response = await updateSupportCenterService(token, data);
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error || "Failed to update support center"
      );
    }
  }
);

const supportSlice = createSlice({
  name: "support",
  initialState: {
    supportCenters: {} as SupportCenters,
    status: "idle",
    error: null,
  } as SupportCenterState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(listSupportCenters.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(
        listSupportCenters.fulfilled,
        (state, action: PayloadAction<SupportCenters>) => {
          state.status = "succeeded";
          state.supportCenters = action.payload;
        }
      )
      .addCase(listSupportCenters.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload as string;
      })
      .addCase(updateSupportCenter.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(
        updateSupportCenter.fulfilled,
        (
          state,
          action: PayloadAction<{ documentName: string; updateDetails: any }>
        ) => {
          state.status = "succeeded";
          const { documentName, updateDetails } = action.payload;
          if (
            state.supportCenters[
              documentName as keyof typeof state.supportCenters
            ]
          ) {
            state.supportCenters[
              documentName as keyof typeof state.supportCenters
            ] = {
              ...state.supportCenters[
                documentName as keyof typeof state.supportCenters
              ],
              ...updateDetails,
            };
          }
        }
      )
      .addCase(updateSupportCenter.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload as string;
      });
  },
});

export const supportReducer = supportSlice.reducer;
